import { useCallback, useState } from 'react';

function useForceUpdate() {
  const [, forceUpdate] = useState(true);

  return useCallback(() => {
    forceUpdate((s) => !s);
  }, []);
}

export default useForceUpdate;

// example

// function App() {
//   const forceUpdate = useForceUpdate()
//   const renderCount = useRef(0)
//
//   useEffect(() => {
//     renderCount.current += 1
//   })
//
//   const onClick = useCallback(() => {
//     forceUpdate()
//   }, [forceUpdate])
//
//   return (
//     <>
//       <button type="button" onClick={onClick}>
//         Use the Force
//       </button>
//       {/* UI will update to reflect the latest ref value! */}
//       <div>Render count: {renderCount.current}</div>
//     </>
//     )
// }
